export function isWeb() {
  return typeof navigator !== "undefined";
}

function getUserAgent() {
  return navigator.userAgent || window.opera;
}

export function isNativeApp() {
  if (!isWeb()) return false;
  return !!window.ReactNativeWebView;
}

export function isStandalone() {
  if (!isWeb()) return false;
  if (window.navigator.standalone) return true;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  if (document.referrer.includes("android-app://")) return true;
  if (window.location.search.includes("mode=standalone")) return true;
  return false;
}

export function isIos() {
  return isWeb() && /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream;
}

export function isAndroid() {
  return isWeb() && /android/i.test(getUserAgent());
}

export function isDesktop() {
  return isWeb() && !isIos() && !isAndroid();
}

export function acceptWebNotifs() {
  return isDesktop() || isStandalone();
}

export function isIosAndNotHomecreen() {
  return isIos() && !window.navigator.standalone;
}
